import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import * as firebase from 'firebase/auth';
import 'firebase/auth';
import { CookieService } from 'ngx-cookie-service';
import { BusinessInput } from '../../models/businessInput.model';
import { CountryCode, CustomerInput } from '../../models/customer.model';
import { CustomerService } from '../../services/customer.service';
import { StorageService } from '../../services/storage.service';
import { LOCAL_STORAGE } from '../../constants/local-storage.constants';
import { COOKIE_STORAGE } from '../../constants/cookie.constants';
import { environment } from 'src/environments/environment';
import { ModalController } from '@ionic/angular';
import { TermsAndConditionComponent } from './terms-and-condition/terms-and-condition.component';
import { BusinessService } from '../../services/business.service';
import { BusinessRegion } from '../../enums/business-type.enum';

@Component({
  selector: 'simpayx-shared-login',
  templateUrl: './shared-login.component.html',
  styleUrls: ['./shared-login.component.scss'],
})
export class SharedLoginComponent implements OnInit {
  @Input() pageDetails: any;
  @Output() isLoginSuccess = new EventEmitter<object>(false);
  loginForm!: FormGroup;
  ng2TelInputOptions: any;
  initCountry!: string;
  submitted = false;
  slotHoldingTime: any = 600;
  countryCode!: string;
  otp: any;
  placeholderString!: string;
  loader: boolean = false;
  userPhone!: string;
  email!: string;
  confirmationResult: any;
  otpSent: boolean = false;
  errorMessage!: string;
  recaptchaVerifier!: firebase.RecaptchaVerifier;
  userName: any;
  isVerifyDisabled: boolean = true;
  isOtpVerified: boolean = true;
  isPresent: boolean = false;
  customerId!: string;

  flag: any;
  toggleOtp: boolean = true;
  cardLabel = 'Add your information';
  customerDetails: any;
  loading: any;
  isFormSubmit: boolean = false;
  businessInput!: BusinessInput;
  constructor(
    private customerService: CustomerService,
    private storageService: StorageService,
    private cookie: CookieService,
    private modalController: ModalController,
    private businessService: BusinessService
  ) {}

  ngOnInit() {
    this.loginForm = new FormGroup({
      acceptTerms: new FormControl(false, [Validators.required]),
      name: new FormControl('', [
        Validators.required,
        Validators.pattern('[a-zA-Z_ ]*'),
      ]),
      phone: new FormControl('', [
        Validators.required,
        Validators.pattern('^(0|[1-9][0-9]*)$'),
      ]),
      email: new FormControl('', [
        Validators.required,
        Validators.pattern(
          '^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,4}$'
        ),
      ]),
    });
    this.setCountryflag();
  }

  async getCustomerByPhone() {
    this.userPhone = this.patchCountryCode();
    this.isFormSubmit = true;
    this.customerService.getCustomerByPhone(this.userPhone).subscribe(
      (result: any) => {
        if (result.data.GetCustomerByPhone) {
          console.log(result.data.GetCustomerByPhone);
          this.customerDetails = result.data.GetCustomerByPhone;
          this.customerId = result.data.GetCustomerByPhone.id;

          this.customerService.setCustomerDetails(
            result.data.GetCustomerByPhone
          );
          this.setCookies();
        }

        // this.loading.dismiss();
        this.storageService.setLocalStorageData(
          LOCAL_STORAGE.CUSTOMER_DETAILS,
          JSON.stringify(result.data.GetCustomerByPhone)
        );
        this.loginForm.reset();
        this.loginForm.enable();
        this.isFormSubmit = false;

        console.log(this.loginForm);

        this.loginForm.reset();

        this.isLoginSuccess.emit({
          loggedIn: true,
          result: { result: result, type: 'get' },
        });
      },
      (error: Error) => {
        console.log(error.message);
        this.isFormSubmit = false;
        if (error.message.includes('404: Not Found')) {
          this.createCustomer();
        }
      }
    );
  }

  setCountryflag() {
    this.businessService.getBusinessSubscription().subscribe((business) => {
      if (business) {
        this.businessInput = business;
      } else {
        this.businessInput = JSON.parse(
          this.storageService.getLocalStorageData(
            LOCAL_STORAGE.BUSINESS_DETAILS
          )
        );
      }

      switch (this.businessInput.address.country) {
        case BusinessRegion.INDIA:
          this.flag = '/assets/country-flag/indianflag.webp';
          this.countryCode = '+91';
          this.placeholderString = '0000000000';
          break;
        case BusinessRegion.US:
          this.flag = '/assets/country-flag/usflag.webp';
          this.countryCode = '+1';
          this.placeholderString = '(000) 000 0000';

          break;

        default:
          break;
      }
    });
  }

  async showTermsConditions() {
    const modal = await this.modalController.create({
      component: TermsAndConditionComponent,
    });
    return await modal.present();
  }

  getNumber(event: any) {
    this.userPhone = event.target.value;
  }

  validateName(event: any) {
    if (
      (event.keyCode >= 15 && event.keyCode !== 32 && event.keyCode <= 64) ||
      event.keyCode >= 123 ||
      (event.keyCode >= 91 && event.keyCode <= 96)
    ) {
      event.preventDefault();
    }
  }

  validateNumber(event: any) {
    console.log(event.target.value);
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode !== 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  createCustomer() {
    this.userName = this.loginForm.controls['name'].value;
    this.email = this.loginForm.controls['email'].value;
    console.log(this.userName, this.userPhone);

    let customer = new CustomerInput(
      '',
      this.userName,
      this.userPhone,
      '',
      this.email,
      '',
      '',
      '',
      []
    );
    this.customerService.createCustomer(customer).subscribe(
      (result: any) => {
        console.log(result);
        if (result.data.CreateCustomer) {
          console.log(result.data.CreateCustomer);
          this.customerDetails = result.data.CreateCustomer;
          this.customerId = result.data.CreateCustomer.id;
          this.customerService.setCustomerDetails(result.data.CreateCustomer);
          this.storageService.setLocalStorageData(
            LOCAL_STORAGE.CUSTOMER_DETAILS,
            JSON.stringify(result.data.CreateCustomer)
          );
          this.setCookies();
        }

        this.isLoginSuccess.emit({
          loggedIn: true,
          result: { result: result, type: 'create' },
        });
      },
      (error: Error) => {
        console.log('error', error);
      }
    );
  }

  setCookies() {
    console.log(this.customerDetails);
    let additionalInfo: any = {
      name: this.customerDetails.name,
      id: this.customerDetails.id,
    };

    let dataStringify: any = JSON.stringify({
      additionalInfo: additionalInfo,
      username: this.customerDetails.phoneNumber,
    });
    this.cookie.set(
      COOKIE_STORAGE.TOKEN,
      dataStringify,
      COOKIE_STORAGE.EXPIRY,
      '',
      ''
    );
  }

  patchCountryCode() {
    this.userPhone = this.loginForm.controls['phone'].value;
    const pattern = /^\d+$/;
    if (this.userPhone.length === 10 && pattern.test(this.userPhone)) {
      if (this.countryCode === CountryCode.F_IN) {
        this.userPhone = CountryCode.IN + this.userPhone;
        return this.userPhone;
      } else {
        this.userPhone = CountryCode.US + this.userPhone;
        return this.userPhone;
      }
    } else {
      this.userPhone = this.userPhone.slice(this.userPhone.length - 10);
      if (this.countryCode === CountryCode.F_IN) {
        this.userPhone = CountryCode.IN + this.userPhone;
        return this.userPhone;
      } else {
        this.userPhone = CountryCode.US + this.userPhone;
        return this.userPhone;
      }
    }
  }
}
